import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import './ErrorComponent.scss';
function ErrorComponent() {
    const history = useHistory();
    const location = useLocation();
    const { userID, token, clientId } = location.state || {};
    
    const handleClick = () => {
        const queryParams = new URLSearchParams({
            userID: userID,
            token: token,
            clientId: clientId,
        }).toString();

        history.push(`/preference?${queryParams}`);
    }

    return (
        <div className="message-confirmation">
            <div className="error-message">
                <img src={`${process.env.PUBLIC_URL}/images/error.svg`} alt='Error'/>
                <h2>Oops! Something went wrong.</h2>
                <p>We encountered an error while processing your request.</p>
                <button onClick={handleClick}>Go Back</button>
            </div>
        </div>
    );
}

export default ErrorComponent;
